import { hydrate, render } from 'preact';
import { App } from './ui/App';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app element');
// Production builds prerender the page into #app (config/prerender.ts); dev starts empty.
if (root.firstElementChild) hydrate(<App />, root);
else render(<App />, root);
